module.exports = __webpack_public_path__ + "static/gallery-img-17-3168139ade29e20477db3d282801af5a.jpg";